// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts


Vue.config.productionTip = false
import 'element-ui/lib/theme-chalk/index.css';
import Element from 'element-ui';
import { Message } from 'element-ui'
Vue.prototype.$message = Message
Vue.use(Element);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js